import React from "react";

const ImprintIcon = ({ size = 20, className = "", strokeWidth = 2 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Kreis mit „i“ – klassisches Impressum/Info-Symbol */}
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth={strokeWidth}/>
    <path d="M12 10v6" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round"/>
    <circle cx="12" cy="7" r="1.2" fill="currentColor"/>
  </svg>
);

export default ImprintIcon;
